import { StrictMode } from 'react';
import { Log } from 'oidc-client-ts';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { BamAuthProvider } from '@/utils/auth/context';
import { envVariables } from '@/utils/env';

import { initDataDogRum } from './utils/datadog/datadogRum';
import { withOptionalDevConfig } from './utils/devModeConfig';
import router from './router';

import '@/index.css';
import './styles/tractie.css';

await withOptionalDevConfig();

initDataDogRum();

Log.setLogger(console);
const { authProvider } = envVariables();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BamAuthProvider engine={authProvider}>
      <RouterProvider router={router} />
    </BamAuthProvider>
  </StrictMode>,
);
